export const INSIGHTS_LOAD = 'INSIGHTS_LOAD'
export const insightsLoad = (
  accountId: string,
  startDate?: string,
  endDate?: string
) => ({
  type: INSIGHTS_LOAD,
  accountId,
  startDate,
  endDate
})

export const INSIGHTS_RELOAD = 'INSIGHTS_RELOAD'
export const insightsReload = (
  accountId: string,
  startDate?: string,
  endDate?: string
) => ({
  type: INSIGHTS_RELOAD,
  accountId,
  startDate,
  endDate
})

export const INSIGHTS_LOAD_SUCCESS = 'INSIGHTS_LOAD_SUCCESS'
export const insightsLoadSuccess = (accountId: string, insights: any[]) => ({
  type: INSIGHTS_LOAD_SUCCESS,
  accountId,
  insights
})

export const INSIGHTS_LOAD_FAILURE = 'INSIGHTS_LOAD_FAILURE'
export const insightsLoadFailure = (accountId: string, error: any) => ({
  type: INSIGHTS_LOAD_FAILURE,
  accountId,
  error
})

export const INSIGHTS_RELOAD_SUCCESS = 'INSIGHTS_RELOAD_SUCCESS'
export const insightsReloadSuccess = (accountId: string, insights: any[]) => ({
  type: INSIGHTS_RELOAD_SUCCESS,
  accountId,
  insights
})
